import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { Paths } from 'utils/constants';
import Utils from 'utils/utils';

import { HeaderButton, LogoType, ProfileButton, Header, LanguageSwitcher } from 'componets/ui';
import { DarkModeSwitcherMini } from 'DarkModeProvider';

import { useTranslate } from 'hooks';

import styles from './index.module.scss';

type RegistrationLayoutProps = {
	children: ReactNode;
	bottom?: ReactNode;
	email?: string;
	fromOverview?: boolean;
	customClassName?: string;
};
export const RegistrationLayout: FC<RegistrationLayoutProps> = ({
	children,
	fromOverview,
	bottom,
	email,
	customClassName,
}) => {
	const { alreadyHaveAccountText, loginText } = useTranslate([
		'alreadyHaveAccountText',
		'loginText',
	]);

	return (
		<div className={styles.root}>
			<div className={styles.content}>
				<Header email={email}>
					<div className={styles.headerInner}>
						{fromOverview ? (
							<Link to={Paths.OVERVIEW}>
								<LogoType />
							</Link>
						) : (
							<a href={Utils.getLinkToWP('')}>
								<LogoType />
							</a>
						)}
						<div className={styles.row}>
							<div className={styles.mobileControls}>
								<LanguageSwitcher />
								<DarkModeSwitcherMini />
							</div>
							{email ? (
								<ProfileButton email={email} />
							) : (
								<HeaderButton text={alreadyHaveAccountText} link="/" title={loginText} />
							)}
						</div>
					</div>
				</Header>

				<div className={styles.center}>
					<div className={cn(styles.box, { [`${customClassName}`]: customClassName })}>
						{children}
					</div>
				</div>
				<div className={styles.bottom}>{bottom}</div>
			</div>
		</div>
	);
};
